/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_R8Inputs */



/**
* | output |
* | --- |
* | "R8 Transfer distribution" |
*
* @param {Rounds_R8Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_r8 = /** @type {((inputs?: Rounds_R8Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_R8Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("R8 Distribution de transfert")
	if (locale === "es") return /** @type {LocalizedString} */ ("R8 Distribución de transferencias")
	if (locale === "pt") return /** @type {LocalizedString} */ ("R8 Distribuição de transferência")
	if (locale === "it") return /** @type {LocalizedString} */ ("R8 Distribuzione transfer")
	return /** @type {LocalizedString} */ ("R8 Transfer distribution")
});